import { handleActions } from "redux-actions";
import moment from "moment";
import { PAYMENTS_MANAGEMENT } from "constants/action-types";

interface IError {
    message: string;
    request: any;
    status: number;
    xhr: any;
}

interface IState {
    result: string[];
    isFetching: boolean;
    isCreating: boolean;
    error: boolean;
    errorObject: IError | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    currencyCode: string;
}

const initialState = {
    result: [],
    isFetching: false,
    isCreating: false,
    error: false,
    errorObject: undefined,
    startDate: moment().utc().subtract(1, "month").startOf("month"),
    endDate: moment().utc().subtract(1, "month").endOf("month"),
    currencyCode: undefined,
};

const paymentsSummaryReducer = handleActions<IState, any>(
    {
        [PAYMENTS_MANAGEMENT.SUMMARY.FETCH.START]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
                error: false,
            };
        },
        [PAYMENTS_MANAGEMENT.SUMMARY.FETCH.COMPLETED]: (state: IState, response): IState => {
            const { payload, error } = response;

            if (error) {
                return {
                    ...state,
                    result: [],
                    isFetching: false,
                    error,
                    errorObject: payload,
                };
            }
            return {
                ...state,
                result: payload,
                isFetching: false,
                error,
            };
        },
        [PAYMENTS_MANAGEMENT.SUMMARY.FILTERS_UPDATE]: (state: IState, response): IState => {
            const { payload } = response;
            return {
                ...state,
                isFetching: false,
                error: false,
                ...payload,
            };
        },
    },
    initialState
);
export type IPaymentsSummaryState = IState;

export default paymentsSummaryReducer;
